function closeFormPopup(event) {
    if (dragging) return;
    
    var formPopup = document.getElementById("form-popup");
    var target = event.target.closest("#form-popup .close");

    if (target) {
        event.preventDefault();

        formPopup.style.visibility = "hidden";
        formPopup.style.display = "none";
        formPopup.style.zIndex = "-1";
    } else {
        return;
    }
}

function setFormPopupCookie() {
    var formPopup = document.getElementById("form-popup");

    const date = new Date();
    date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
    let expires = "; expires=" + date.toGMTString();
    
    var hasCookie = document.cookie.indexOf("formPopup");
    if (formPopup) {
        if (hasCookie == -1) {
            formPopup.style.display = "block";
            document.cookie = "formPopup=hasBeenSeen" + expires + "; path=/";
        } else {
            formPopup.style.visibility = "hidden";
            formPopup.style.display = "none";
            formPopup.style.zIndex = "-1";
        }
    }
}

document.addEventListener("DOMContentLoaded", function () {
    setFormPopupCookie();

    document.addEventListener("click", closeFormPopup);
    document.addEventListener("touchend", closeFormPopup);
});